import { render, staticRenderFns } from "./PointProgramsActivateDeactivateProgramsContest.vue?vue&type=template&id=3d420ee4&"
import script from "./PointProgramsActivateDeactivateProgramsContest.vue?vue&type=script&lang=js&"
export * from "./PointProgramsActivateDeactivateProgramsContest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports